<template>
  <div class="mb-md-5 mb-2" v-if="reference">
    <div class="sub-title">Ga verder</div>

    <div class="link" @click="select">
      <font-awesome-icon class="font-awesome-icon" icon="tasks"/>&nbsp;{{ reference }}
    </div>
  </div>
</template>

<script>
  import { TOOL_LOAD_CART_FROM_LOCAL_STORAGE } from '../../store/types'

  export default {
    computed: {
      reference() {
        let cart = JSON.parse(localStorage.getItem('cart'))
        return cart ? cart.reference : null
      }
    },
    methods: {
      select() {
        this.$store.dispatch(TOOL_LOAD_CART_FROM_LOCAL_STORAGE)
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
